<template>
  <form class="mt-2" id="form-modal">
    <!-- description input -->
    <div class="form-group">
      <label class="label-form">Description:</label>
      <textarea class="form-control" v-model="note_description" placeholder="note description">{{ getNote }}</textarea>
    </div>

    <!-- buttons -->
    <div class="form-footer text-right">
      <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">
        Close
      </button>
      <button type="button" class="btn btn-primary btn-sm ml-1" @click="save">
        Save
      </button>
    </div>
  </form>
</template>

<script>
  // import Multiselect from 'vue-multiselect';
  import axios from "axios";

  export default {
    props: ["action", "formData"],

    data: function () {
      return {
        note_description: "",
      };
    },

    computed: {
      getNote: function () {
        const permission = {
      headers: {
        'X-Permission': 'all_organization_note' 
      }
    };
        axios
          .get("/admin/users/get-user-note?user_id=" + this.formData,permission)
          .then((response) => {
            this.note_description = response.data;
            return response.data;
          });
      },
    },

    methods: {
      save() {
        let user_id = this.formData;
        let self = this;
        let note = self.note_description;

        this.$store
          .dispatch("users/saveUserNote", [note, user_id])
          .then(() => {
            //self.note_description = {};
            // send successful message
            this.$toast.success("Note has been added successfully");
            window.$("#modal").modal("hide");
          })
          .catch((error) => {
            let response = error.response;
            this.$toast.error(response.data.message);
          });
      },
    },
  };
</script>